import { create } from '@storybook/theming';

export const storybook_theme = create({
  base: 'light',
  brandTitle: 'Geovistory design system',
  brandUrl: 'https://www.geovistory.org',
  brandImage: 'https://www.geovistory.org/geovistory-logo.svg',
  brandTarget: '_self',
});
